import React from "react";
import { Card, Table, Spin, Empty, Progress, Tag } from "antd";

const QoEBreakdownTable = ({ title, data, loading }) => {
  if (loading) {
    return (
      <Card title={title} size="small">
        <div style={{ textAlign: "center", padding: 20 }}><Spin /></div>
      </Card>
    );
  }

  if (!data?.data || data.data.length === 0) {
    return (
      <Card title={title} size="small">
        <Empty description="Sem dados" />
      </Card>
    );
  }

  const formatWatchTime = (seconds) => {
    if (!seconds) return "0h";
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    if (hours > 0) return `${hours.toLocaleString()}h ${mins}m`;
    return `${mins}m`;
  };

  const columns = [
    {
      title: "Campo",
      dataIndex: "field",
      key: "field",
      ellipsis: true,
      render: (val) => <span style={{ fontWeight: 500 }}>{val || "N/A"}</span>,
    },
    {
      title: "Viewer Exp Score",
      dataIndex: "viewerExperienceScore",
      key: "viewerExperienceScore",
      width: 160,
      sorter: (a, b) => (a.viewerExperienceScore || 0) - (b.viewerExperienceScore || 0),
      render: (val) => {
        const pct = val ? val * 100 : 0;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Progress
              percent={pct}
              showInfo={false}
              size="small"
              strokeColor={pct >= 80 ? "#52c41a" : pct >= 50 ? "#fa8c16" : "#ff4d4f"}
              style={{ flex: 1 }}
            />
            <span style={{ fontSize: 12, minWidth: 40 }}>{pct.toFixed(1)}%</span>
          </div>
        );
      },
    },
    {
      title: "Views",
      dataIndex: "views",
      key: "views",
      width: 90,
      sorter: (a, b) => (a.views || 0) - (b.views || 0),
      render: (val) => (val || 0).toLocaleString(),
    },
    {
      title: "Watch Time",
      dataIndex: "totalWatchTimeSeconds",
      key: "totalWatchTimeSeconds",
      width: 110,
      sorter: (a, b) => (a.totalWatchTimeSeconds || 0) - (b.totalWatchTimeSeconds || 0),
      render: (val) => formatWatchTime(val),
    },
    {
      title: "Negative Impact",
      dataIndex: "negativeImpact",
      key: "negativeImpact",
      width: 130,
      sorter: (a, b) => (a.negativeImpact || 0) - (b.negativeImpact || 0),
      render: (val) => {
        if (!val) return <Tag color="green">0</Tag>;
        const color = val > 100 ? "red" : val > 50 ? "orange" : "green";
        return <Tag color={color}>{val}</Tag>;
      },
    },
  ];

  return (
    <Card
      title={title}
      size="small"
      extra={<span style={{ color: "#888", fontSize: 12 }}>{data.dimension}</span>}
    >
      <Table
        columns={columns}
        dataSource={data.data}
        rowKey="field"
        pagination={false}
        size="small"
        scroll={{ x: 600 }}
      />
    </Card>
  );
};

export default QoEBreakdownTable;
